export default function GenderIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.03 1.47a.75.75 0 0 1 0 1.06q-.624.626-1.12 1.32l1.207 1.207a.75.75 0 0 1-1.06 1.06l-.948-.948q-.316.622-.535 1.266l4.879 4.878a1 1 0 0 1 .096.118 10 10 0 0 0 1.207-.502L15.748 7.92a.75.75 0 1 1 1.06-1.06l3.276 3.275q.73-.512 1.386-1.166a.75.75 0 1 1 1.06 1.06c-2.622 2.623-6.264 3.854-9.556 3.213.75 3.175-.4 6.744-2.944 9.287a.75.75 0 1 1-1.06-1.06 10 10 0 0 0 1.158-1.395l-1.354-1.353a.75.75 0 1 1 1.061-1.06l1.063 1.062q.279-.606.463-1.228l-.048-.044L6.5 12.64q-.66.195-1.302.499l2.831 2.83a.75.75 0 0 1-1.06 1.062l-3.112-3.113q-.7.488-1.328 1.112a.75.75 0 0 1-1.06-1.06c2.543-2.544 6.112-3.693 9.287-2.944-.64-3.292.59-6.934 3.213-9.556a.75.75 0 0 1 1.06 0m.82 10.362-3.68-3.682c-.159 1.17-.073 2.334.271 3.412 1.078.344 2.242.43 3.412.271m-4.52 1.122c.299.867.413 1.8.353 2.747l-3.384-3.384c.947-.06 1.88.054 2.747.353l.212.072z"
        fill="currentColor"
      />
    </svg>
  );
}
